// src/pages/AboutPage.js
import React from 'react';
import '../styles/AboutPage.css';

function AboutPage() {
  return (
    <div className="about-page">
      <section className="about-hero">
        <h1 className="about-title">About Tact Transport</h1>
        <p className="about-tagline">Luxury Transportation Redefined</p>
      </section>

      <section className="about-section">
        <div className="about-content">
          <h2>Our Story</h2>
          <p>
            Founded with a vision to transform luxury transportation in Texas, Louisiana, and Oklahoma,
            Tact Transport has become synonymous with sophistication, reliability, and exceptional service.
            What began as a passion for delivering unparalleled travel experiences has grown into a
            premier transportation company serving discerning clients across the region.
          </p>
          <p>
            Our journey started with a simple belief: that every journey should be an experience worth
            remembering. Today, we continue to uphold that founding principle, combining modern luxury
            vehicles with professional chauffeur services to create memorable moments for our clients.
          </p>
        </div>
      </section>

      <section className="about-section about-section-alt">
        <div className="about-content">
          <h2>Our Mission</h2>
          <p>
            At Tact Transport, our mission is to provide exceptional luxury transportation services
            that exceed expectations. We are committed to delivering safe, comfortable, and stylish
            travel experiences while maintaining the highest standards of professionalism and customer care.
          </p>
        </div>
      </section>

      <section className="about-section">
        <div className="about-content">
          <h2>Our Values</h2>
          <div className="values-grid">
            <div className="value-item">
              <h3>Excellence</h3>
              <p>We strive for excellence in every aspect of our service, from vehicle maintenance to customer interaction.</p>
            </div>
            <div className="value-item">
              <h3>Reliability</h3>
              <p>Punctuality and dependability are the cornerstones of our business. When you book with us, you can count on us.</p>
            </div>
            <div className="value-item">
              <h3>Safety</h3>
              <p>Your safety is our top priority. Our vehicles are meticulously maintained and our chauffeurs are thoroughly vetted.</p>
            </div>
            <div className="value-item">
              <h3>Discretion</h3>
              <p>We understand the importance of privacy. Our professional team ensures confidentiality at all times.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-section about-section-alt">
        <div className="about-content">
          <h2>Why Choose Tact Transport?</h2>
          <ul className="why-choose-list">
            <li>Premium fleet of luxury vehicles including Mercedes, Range Rover, Cadillac, and GMC</li>
            <li>Professional, experienced chauffeurs with extensive background checks</li>
            <li>24/7 availability for your transportation needs</li>
            <li>Competitive pricing with transparent quotes</li>
            <li>Serving Texas, Louisiana, and Oklahoma</li>
            <li>Customizable services for corporate events, weddings, proms, and more</li>
            <li>Armed security services available upon request</li>
          </ul>
        </div>
      </section>

      <section className="about-section about-cta">
        <div className="about-content">
          <h2>Experience the Difference</h2>
          <p>
            Ready to elevate your travel experience? Let Tact Transport show you what true luxury
            transportation feels like. Contact us today to book your ride or learn more about our services.
          </p>
          <div className="about-cta-buttons">
            <a href="/booking" className="about-button primary">Book Now</a>
            <a href="/fleet" className="about-button secondary">View Our Fleet</a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutPage;
